import {Container, rem, Title, Box, Button, Group} from '@mantine/core';
import {IconMoon, IconSun} from "@tabler/icons-react";
import {ActionIcon, useMantineColorScheme} from "@mantine/core";
import {useDocumentStyleEffect} from "../hooks/useDocumentStyleEffect";
import {Link, useLocation} from "react-router-dom";


export function Header() {

    const currentPage = useLocation().pathname;

    // sets color scheme for app
    const {colorScheme, setColorScheme} = useMantineColorScheme();
    useDocumentStyleEffect();

    return (
        <Box
            mb={rem(60)}
            bg={"var(--mantine-color-body)"}
            component={"header"}
            style={{
                boxShadow: " 0 0 8px var(--mantine-color-body)",
                zIndex: "1000"
            }}
            top={0} pos='sticky'
        >
            <Container fluid py="md" style={{
                justifyContent: "space-between",
                alignItems: "center",
                display: "flex"
            }}>
                <Link to={'/'} style={{textDecoration: 'none'}}>
                    <Title order={4} c="light-dark(#000000, #ffffff)">
                        LAGG: Looking At Genomes Graphically
                    </Title>
                </Link>

                <Group gap="xl">
                    {(currentPage === `/demo`) ? (
                            <Button component="a" href="/demo" radius="xl" color="#2A83A1">
                                CGR Demo
                            </Button>
                        ) :
                        (
                            <Button component="a" href="/demo" variant="transparent">
                                CGR Demo
                            </Button>
                        )
                    }

                    {(currentPage === `/docs` || currentPage === `/`) ? (
                            <Button component="a" href="/docs" radius="xl" color="#2A83A1">
                                Docs
                            </Button>
                        ) :
                        (
                            <Button component="a" href="/docs" variant="transparent">
                                Docs
                            </Button>
                        )
                    }

                    <ActionIcon
                        onClick={() => setColorScheme(colorScheme === "light" ? "dark" : "light")}
                        variant="default"
                        size="xl"
                        aria-label="Toggle color scheme"
                    >
                        <IconSun stroke={1.5} display={colorScheme === "dark" ? "none" : "block"}/>
                        <IconMoon stroke={1.5} display={colorScheme === "light" ? "none" : "block"}/>
                    </ActionIcon>
                </Group>

            </Container>
        </Box>
    );
}